// 报名管理
import services from '../../services'
import devConfig from '@/config/index'
import { __replaceDotCom } from '@/utils/tools'
let hostUrl = devConfig.gateway.MsaGatewayAddress
hostUrl = __replaceDotCom(hostUrl, true)
const state = {
  downloadTemplateUrl: `${hostUrl}com.huawei.it.mbs.eventsgo:eventsgomedia/eventsgo/media/servlet/download?`,
  mobilePath: `https://${process.env.VUE_APP_BUILD_ENV === 'prod' ? location.host : 'esign.cbg.huawei.com'}/eventsgo/mobile`,
  groupList: [],
  empPermList: [],
  audienceClassList: [] // 受众下拉列表
}
const getters = {
}
const actions = {
  getClassListByAllAct(context, param) {
    return services.registManageSer.getClassListByAll(param).then(({ data = {} }) => {
      const lang = context.rootState.common.lang
      const list = data && data.data || []
      list.forEach(item => { item.audienceClassName = lang === 'zh_CN' ? item.audienceClassNameCn : item.audienceClassNameEn })
      context.commit('setAudienceClassList', list)
    })
  },
  findGuestDetailByIdAct(context, param) {
    return services.registManageSer.findGuestDetailByIdSer(param)
  },
  getGroupListAct(context, param) {
    return services.registManageSer.getGroupListSer(param)
  },
  // 查询座位列表
  findSeatListAct(context, param) {
    return services.registManageSer.findSeatListSer(param)
  },
  // 导出座位列表
  exportSeatAct(context, param) {
    return services.registManageSer.exportSeatSer(param)
  },
  // 添加座位
  batchCreateSeatAct(context, param) {
    return services.registManageSer.batchCreateSeatSer(param)
  },
  // 修改座位
  batchUpdateSeatAct(context, param) {
    return services.registManageSer.batchUpdateSeatSer(param)
  },
  // 删除座位
  batchDeleteSeatAct(context, param) {
    return services.registManageSer.batchDeleteSeatSer(param)
  },
  // 删除作废座位
  batchDeleteVoidedSeatAct(context, param) {
    return services.registManageSer.batchDeleteVoidedSeatSer(param)
  },
  // 新增嘉宾
  createGuestAct(context, param) {
    return services.registManageSer.createGuestSer(param)
  },
  // 修改嘉宾
  updateGuestAct(context, param) {
    return services.registManageSer.updateGuestSer(param)
  },
  // 导出嘉宾
  exportGuestAct(context, param) {
    return services.registManageSer.exportGuestSer(param)
  },
  // 嘉宾取消参会
  cancelGuestAct(context, param) {
    return services.registManageSer.cancelGuestSer(param)
  },
  // 查询嘉宾列表
  findGuestListAct(context, param) {
    return services.registManageSer.findGuestListSer(param)
  },
  // 查询嘉宾座位列表
  findGuestSeatListAct(context, param) {
    return services.registManageSer.findGuestSeatListSer(param)
  },
  // 查询隐私配置列表
  findPrivacyListAct(context, param) {
    return services.registManageSer.findPrivacyListSer(param)
  },
  // 新增、修改隐私配置
  addOrUpdatePrivacyAct(context, param) {
    return services.registManageSer.addOrUpdatePrivacySer(param)
  },
  // 隐私配置详情
  getPrivacyInfoAct(context, param) {
    return services.registManageSer.getPrivacyInfoSer(param)
  },
  // 批量删除隐私配置
  deletePrivacyListAct(context, param) {
    return services.registManageSer.deletePrivacyListSer(param)
  },
  // 获取欧盟标识
  getEUFlageAct(context, param) {
    return services.registManageSer.getEUFlageSer(param)
  },
  // 修改审批配置
  updateApproveConfigAct(context, param) {
    return services.registManageSer.updateApproveConfigSer(param)
  },
  // 查询短信配置
  querySmsConfigAct(context, param) {
    return services.registManageSer.querySmsConfigSer(param)
  },
  // 更新短信配置
  updateSmsConfigAct(context, param) {
    return services.registManageSer.updateSmsConfigSer(param)
  },
  // 保存短信配置
  saveSmsConfigAct(context, param) {
    return services.registManageSer.saveSmsConfigSer(param)
  },
  // 获取审批人列表
  getApproversAct(context, param) {
    return services.registManageSer.getApproversSer(param)
  },
  // 新增演讲嘉宾
  createSpeakerAct(context, param) {
    return services.registManageSer.createSpeakerSer(param)
  },
  // 修改演讲嘉宾
  updateSpeakerAct(context, param) {
    return services.registManageSer.updateSpeakerSer(param)
  },
  // 批量删除演讲嘉宾
  deleteSpeakerAct(context, param) {
    return services.registManageSer.deleteSpeakerSer(param)
  },
  // 分页查询演讲嘉宾
  getSpeakerListAct(context, param) {
    return services.registManageSer.getSpeakerListSer(param)
  },
  // 转赠审批管理分页列表
  getSeatTransListAct(context, param) {
    return services.registManageSer.getSeatTransListSer(param)
  },
  // 批量通过审批
  batchPassSeatAct(context, param) {
    return services.registManageSer.batchPassSeatSer(param)
  },
  // 批量驳回审批
  batchRejectSeatAct(context, param) {
    return services.registManageSer.batchRejectSeatSer(param)
  },
  // 分页查询员工组别
  getEmpGroupListAct(context, param) {
    return services.registManageSer.getEmpGroupListSer(param)
  },
  // 查询所有员工组别
  getEmpGroupListAllAct(context, param) {
    return services.registManageSer.getEmpGroupListAllSer(param).then(({ data = {} }) => {
      const lang = context.rootState.common.lang
      const list = data.data || []
      const now = Date.now()
      list.forEach(item => {
        item.groupName = lang === 'zh_CN' ? item.nameCn : item.nameEn
        item.deaded = item.signDeadline && now > new Date(item.signDeadline)
      })
      context.commit('setGroupList', list)
    })
  },
  // 批量新增员工组别
  batchCreateEmpGrouopAct(context, param) {
    return services.registManageSer.batchCreateEmpGrouopSer(param)
  },
  // 批量修改员工组别
  batchUpdateEmpGrouopAct(context, param) {
    return services.registManageSer.batchUpdateEmpGrouopSer(param)
  },
  // 批量删除员工组别
  batchDeleteEmpGrouopAct(context, param) {
    return services.registManageSer.batchDeleteEmpGrouopSer(param)
  },
  // 导出员工组别
  exportEmpGrouopAct(context, param) {
    return services.registManageSer.exportEmpGrouopSer(param)
  },
  // 查询员工根据Id
  getEmpgroupByIdAct(context, param) {
    return services.registManageSer.getEmpgroupByIdSer(param)
  },
  // 新增员工报名
  createEmpAct(context, param) {
    return services.registManageSer.createEmpSer(param)
  },
  // 修改员工报名
  updateEmpAct(context, param) {
    return services.registManageSer.updateEmpSer(param)
  },
  // 导出员工报名
  exportEmpAct(context, param) {
    return services.registManageSer.exportEmpSer(param)
  },
  // 上传员工头像
  uploadEmpAct(context, param) {
    return services.registManageSer.uploadEmpSer(param)
  },
  // 分页查询议程配置
  getActivityListAct(context, param) {
    return services.registManageSer.getActivityListSer(param)
  },
  // 批量添加议程配置
  batchAddActivityAct(context, param) {
    return services.registManageSer.batchAddActivitySer(param)
  },
  // 批量修改议程配置
  batchUpdateActivityAct(context, param) {
    return services.registManageSer.batchUpdateActivitySer(param)
  },
  // 批量删除议程配置
  batchDeleteActivityAct(context, param) {
    return services.registManageSer.batchDeleteActivitySer(param)
  },
  // 导入模板
  importExcelAct(context, param) {
    return services.registManageSer.importExcelSer(param)
  },
  // 导入任务查询
  findImportExcelByTaskIdAct(context, param) {
    return services.registManageSer.findImportExcelByTaskIdSer(param)
  },
  // 发送图片邮件
  sendPictureEmailAct(context, param) {
    return services.registManageSer.sendPictureEmailSer(param)
  },
  // 发送员工参会消息
  sendAttendMsgAct(context, param) {
    return services.registManageSer.sendAttendMsg(param)
  },
  // 发送嘉宾参会消息
  sendGuestAttendMsgAct(context, param) {
    return services.registManageSer.sendGuestAttendMsg(param)
  },
  // 代表列表
  getTaskListAct(context, param) {
    return services.registManageSer.getTaskList(param)
  },
  // 批量审批
  batchApproveEmpAct(context, param) {
    return services.registManageSer.batchApproveEmp(param)
  },
  batchReviewApproveAct(context, param) {
    return services.registManageSer.batchReviewApprove(param)
  },
  // 批量新增
  addEmpPermsAct(context, param) {
    return services.registManageSer.addEmpPerms(param)
  },
  // 批量修改
  updateEmpPermsAct(context, param) {
    return services.registManageSer.updateEmpPerms(param)
  },
  // 批量删除
  delEmpPermsAct(context, param) {
    return services.registManageSer.delEmpPerms(param)
  },
  getEmpAllPermsAct(context, param) {
    return services.registManageSer.getEmpPermListAll(param).then(({ data }) => {
      const lang = context.rootState.common.lang
      const list = data.data || []
      list.forEach(item => { item.empPermissionName = lang === 'zh_CN' ? item.empPermissionNameCn : item.empPermissionNameEn })
      if (data.resultType === 0) {
        context.commit('setEmpPermList', list)
      }
    })
  },
  // 统计查询
  staticGuestAudienceCountAct(context, param) {
    return services.registManageSer.staticGuestAudienceCountSer(param)
  },
  // 统计导出
  exportStaticGuestCountAct(context, param) {
    return services.registManageSer.exportStaticGuestCountSer(param)
  },
  // 黑名单清单列表
  getBlacklistAct(context, param) {
    return services.registManageSer.getBlacklistSer(param)
  },
  // 黑名单清单根据ID查询
  getBlacklistByIdAct(context, param) {
    return services.registManageSer.getBlacklistByIdSer(param)
  },
  // 黑名单清单创建
  createBlacklistAct(context, param) {
    return services.registManageSer.createBlacklistSer(param)
  },
  // 黑名单清单更新
  updateBlacklistAct(context, param) {
    return services.registManageSer.updateBlacklistSer(param)
  },
  // 黑名单清单删除
  deleteBlacklistAct(context, param) {
    return services.registManageSer.deleteBlacklistSer(param)
  },
  // 黑名单清单导出
  exportBlacklistAct(context, param) {
    return services.registManageSer.exportBlacklistSer(param)
  },
  // 黑名单注册列表
  getBlacklistRegisterAct(context, param) {
    return services.registManageSer.getBlacklistRegisterSer(param)
  },
  // 导出黑名单注册
  exportBlacklistRegisterAct(context, param) {
    return services.registManageSer.exportBlacklistRegisterSer(param)
  },
  // 审批签到统计
  signApprovedStatisticAct(context, param) {
    return services.registManageSer.signApprovedStatisticSer(param)
  },
  // 审批签到统计导出
  signApprovedStatisticExportAct(context, param) {
    return services.registManageSer.signApprovedStatisticExportSer(param)
  },
  // 审批日志
  reviewTaskListAct(context, param) {
    return services.registManageSer.reviewTaskListSer(param)
  }

}
const mutations = {
  setGroupList(state, payload) {
    state.groupList = payload
  },
  setEmpPermList(state, payload) {
    state.empPermList = payload
  },
  setAudienceClassList(state, payload) {
    state.audienceClassList = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
